import React from 'react';

const Header = () => {
  return (
    <header
      data-test="header"
      className="h-auto bg-[url('https://tii.imgix.net/global/corporate/hero-mobile-people-on-laptops.png?auto=format')] bg-cover py-48 sm:bg-[url('https://tii.imgix.net/global/corporate/hero-desktop-people-on-laptops.png?auto=format')] sm:py-[62px] md:py-96"
    >
      <div className="mx-16 flex flex-col items-center">
        <h1 className="my-0 text-center font-suisse-works text-headline-md text-white md:text-headline-xl">
          Corporate Opportunities
        </h1>
        <p className="mb-0 mt-8 max-w-[600px] text-center font-suisse-neue text-body-md text-white sm:mt-16 sm:text-subheadline-sm md:text-subheadline-md">
          Custom offerings that provide access to the leading tech and finance publication.
        </p>
        <div className="mt-24 flex flex-col items-center font-suisse-intl-mono text-overline-md sm:flex-row md:text-overline-lg">
          <a href="#IntroAndForm" className="anchor-link text-primary-magenta">
            Group Subscriptions
          </a>
          <div className="m-16 w-36 border-0 border-t border-solid border-white sm:rotate-45 sm:transform" />
          <a href="#Education" className="anchor-link text-primary-magenta">
            Higher Education
          </a>
          <div className="m-16 w-36 border-0 border-t border-solid border-white sm:rotate-45 sm:transform" />
          <a href="#Licensing" className="anchor-link text-primary-magenta">
            Content Licensing
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
